const ACTIVE = 'active';
const FAILED = 'failed';
const PENDING = 'pending';
const CANCELED = 'canceled';

export {
    ACTIVE,
    FAILED,
    PENDING,
    CANCELED
};
